var Be = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, Ne = Math.ceil, re = Math.floor, Q = "[BigNumber Error] ", Re = Q + "Number primitive has more than 15 significant digits: ", oe = 1e14, L = 14, we = 9007199254740991, ve = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], ce = 1e7, V = 1e9;
function Ce(t) {
  var h, g, $, u = O.prototype = { constructor: O, toString: null, valueOf: null }, N = new O(1), m = 20, w = 4, D = -7, E = 21, R = -1e7, T = 1e7, _ = !1, x = 1, C = 0, S = {
    prefix: "",
    groupSize: 3,
    secondaryGroupSize: 0,
    groupSeparator: ",",
    decimalSeparator: ".",
    fractionGroupSize: 0,
    fractionGroupSeparator: " ",
    // non-breaking space
    suffix: ""
  }, b = "0123456789abcdefghijklmnopqrstuvwxyz", z = !0;
  function O(e, r) {
    var i, c, l, d, a, n, s, f, o = this;
    if (!(o instanceof O)) return new O(e, r);
    if (r == null) {
      if (e && e._isBigNumber === !0) {
        o.s = e.s, !e.c || e.e > T ? o.c = o.e = null : e.e < R ? o.c = [o.e = 0] : (o.e = e.e, o.c = e.c.slice());
        return;
      }
      if ((n = typeof e == "number") && e * 0 == 0) {
        if (o.s = 1 / e < 0 ? (e = -e, -1) : 1, e === ~~e) {
          for (d = 0, a = e; a >= 10; a /= 10, d++) ;
          d > T ? o.c = o.e = null : (o.e = d, o.c = [e]);
          return;
        }
        f = String(e);
      } else {
        if (!Be.test(f = String(e))) return $(o, f, n);
        o.s = f.charCodeAt(0) == 45 ? (f = f.slice(1), -1) : 1;
      }
      (d = f.indexOf(".")) > -1 && (f = f.replace(".", "")), (a = f.search(/e/i)) > 0 ? (d < 0 && (d = a), d += +f.slice(a + 1), f = f.substring(0, a)) : d < 0 && (d = f.length);
    } else {
      if (j(r, 2, b.length, "Base"), r == 10 && z)
        return o = new O(e), B(o, m + o.e + 1, w);
      if (f = String(e), n = typeof e == "number") {
        if (e * 0 != 0) return $(o, f, n, r);
        if (o.s = 1 / e < 0 ? (f = f.slice(1), -1) : 1, O.DEBUG && f.replace(/^0\.0*|\./, "").length > 15)
          throw Error(Re + e);
      } else
        o.s = f.charCodeAt(0) === 45 ? (f = f.slice(1), -1) : 1;
      for (i = b.slice(0, r), d = a = 0, s = f.length; a < s; a++)
        if (i.indexOf(c = f.charAt(a)) < 0) {
          if (c == ".") {
            if (a > d) {
              d = s;
              continue;
            }
          } else if (!l && (f == f.toUpperCase() && (f = f.toLowerCase()) || f == f.toLowerCase() && (f = f.toUpperCase()))) {
            l = !0, a = -1, d = 0;
            continue;
          }
          return $(o, String(e), n, r);
        }
      n = !1, f = g(f, r, 10, o.s), (d = f.indexOf(".")) > -1 ? f = f.replace(".", "") : d = f.length;
    }
    for (a = 0; f.charCodeAt(a) === 48; a++) ;
    for (s = f.length; f.charCodeAt(--s) === 48; ) ;
    if (f = f.slice(a, ++s)) {
      if (s -= a, n && O.DEBUG && s > 15 && (e > we || e !== re(e)))
        throw Error(Re + o.s * e);
      if ((d = d - a - 1) > T)
        o.c = o.e = null;
      else if (d < R)
        o.c = [o.e = 0];
      else {
        if (o.e = d, o.c = [], a = (d + 1) % L, d < 0 && (a += L), a < s) {
          for (a && o.c.push(+f.slice(0, a)), s -= L; a < s; )
            o.c.push(+f.slice(a, a += L));
          a = L - (f = f.slice(a)).length;
        } else
          a -= s;
        for (; a--; f += "0") ;
        o.c.push(+f);
      }
    } else
      o.c = [o.e = 0];
  }
  O.clone = Ce, O.ROUND_UP = 0, O.ROUND_DOWN = 1, O.ROUND_CEIL = 2, O.ROUND_FLOOR = 3, O.ROUND_HALF_UP = 4, O.ROUND_HALF_DOWN = 5, O.ROUND_HALF_EVEN = 6, O.ROUND_HALF_CEIL = 7, O.ROUND_HALF_FLOOR = 8, O.EUCLID = 9, O.config = O.set = function(e) {
    var r, i;
    if (e != null)
      if (typeof e == "object") {
        if (e.hasOwnProperty(r = "DECIMAL_PLACES") && (i = e[r], j(i, 0, V, r), m = i), e.hasOwnProperty(r = "ROUNDING_MODE") && (i = e[r], j(i, 0, 8, r), w = i), e.hasOwnProperty(r = "EXPONENTIAL_AT") && (i = e[r], i && i.pop ? (j(i[0], -V, 0, r), j(i[1], 0, V, r), D = i[0], E = i[1]) : (j(i, -V, V, r), D = -(E = i < 0 ? -i : i))), e.hasOwnProperty(r = "RANGE"))
          if (i = e[r], i && i.pop)
            j(i[0], -V, -1, r), j(i[1], 1, V, r), R = i[0], T = i[1];
          else if (j(i, -V, V, r), i)
            R = -(T = i < 0 ? -i : i);
          else
            throw Error(Q + r + " cannot be zero: " + i);
        if (e.hasOwnProperty(r = "CRYPTO"))
          if (i = e[r], i === !!i)
            if (i)
              if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                _ = i;
              else
                throw _ = !i, Error(Q + "crypto unavailable");
            else
              _ = i;
          else
            throw Error(Q + r + " not true or false: " + i);
        if (e.hasOwnProperty(r = "MODULO_MODE") && (i = e[r], j(i, 0, 9, r), x = i), e.hasOwnProperty(r = "POW_PRECISION") && (i = e[r], j(i, 0, V, r), C = i), e.hasOwnProperty(r = "FORMAT"))
          if (i = e[r], typeof i == "object") S = i;
          else throw Error(Q + r + " not an object: " + i);
        if (e.hasOwnProperty(r = "ALPHABET"))
          if (i = e[r], typeof i == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(i))
            z = i.slice(0, 10) == "0123456789", b = i;
          else
            throw Error(Q + r + " invalid: " + i);
      } else
        throw Error(Q + "Object expected: " + e);
    return {
      DECIMAL_PLACES: m,
      ROUNDING_MODE: w,
      EXPONENTIAL_AT: [D, E],
      RANGE: [R, T],
      CRYPTO: _,
      MODULO_MODE: x,
      POW_PRECISION: C,
      FORMAT: S,
      ALPHABET: b
    };
  }, O.isBigNumber = function(e) {
    if (!e || e._isBigNumber !== !0) return !1;
    if (!O.DEBUG) return !0;
    var r, i, c = e.c, l = e.e, d = e.s;
    e: if ({}.toString.call(c) == "[object Array]") {
      if ((d === 1 || d === -1) && l >= -V && l <= V && l === re(l)) {
        if (c[0] === 0) {
          if (l === 0 && c.length === 1) return !0;
          break e;
        }
        if (r = (l + 1) % L, r < 1 && (r += L), String(c[0]).length == r) {
          for (r = 0; r < c.length; r++)
            if (i = c[r], i < 0 || i >= oe || i !== re(i)) break e;
          if (i !== 0) return !0;
        }
      }
    } else if (c === null && l === null && (d === null || d === 1 || d === -1))
      return !0;
    throw Error(Q + "Invalid BigNumber: " + e);
  }, O.maximum = O.max = function() {
    return K(arguments, -1);
  }, O.minimum = O.min = function() {
    return K(arguments, 1);
  }, O.random = function() {
    var e = 9007199254740992, r = Math.random() * e & 2097151 ? function() {
      return re(Math.random() * e);
    } : function() {
      return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
    };
    return function(i) {
      var c, l, d, a, n, s = 0, f = [], o = new O(N);
      if (i == null ? i = m : j(i, 0, V), a = Ne(i / L), _)
        if (crypto.getRandomValues) {
          for (c = crypto.getRandomValues(new Uint32Array(a *= 2)); s < a; )
            n = c[s] * 131072 + (c[s + 1] >>> 11), n >= 9e15 ? (l = crypto.getRandomValues(new Uint32Array(2)), c[s] = l[0], c[s + 1] = l[1]) : (f.push(n % 1e14), s += 2);
          s = a / 2;
        } else if (crypto.randomBytes) {
          for (c = crypto.randomBytes(a *= 7); s < a; )
            n = (c[s] & 31) * 281474976710656 + c[s + 1] * 1099511627776 + c[s + 2] * 4294967296 + c[s + 3] * 16777216 + (c[s + 4] << 16) + (c[s + 5] << 8) + c[s + 6], n >= 9e15 ? crypto.randomBytes(7).copy(c, s) : (f.push(n % 1e14), s += 7);
          s = a / 7;
        } else
          throw _ = !1, Error(Q + "crypto unavailable");
      if (!_)
        for (; s < a; )
          n = r(), n < 9e15 && (f[s++] = n % 1e14);
      for (a = f[--s], i %= L, a && i && (n = ve[L - i], f[s] = re(a / n) * n); f[s] === 0; f.pop(), s--) ;
      if (s < 0)
        f = [d = 0];
      else {
        for (d = -1; f[0] === 0; f.splice(0, 1), d -= L) ;
        for (s = 1, n = f[0]; n >= 10; n /= 10, s++) ;
        s < L && (d -= L - s);
      }
      return o.e = d, o.c = f, o;
    };
  }(), O.sum = function() {
    for (var e = 1, r = arguments, i = new O(r[0]); e < r.length; ) i = i.plus(r[e++]);
    return i;
  }, g = /* @__PURE__ */ function() {
    var e = "0123456789";
    function r(i, c, l, d) {
      for (var a, n = [0], s, f = 0, o = i.length; f < o; ) {
        for (s = n.length; s--; n[s] *= c) ;
        for (n[0] += d.indexOf(i.charAt(f++)), a = 0; a < n.length; a++)
          n[a] > l - 1 && (n[a + 1] == null && (n[a + 1] = 0), n[a + 1] += n[a] / l | 0, n[a] %= l);
      }
      return n.reverse();
    }
    return function(i, c, l, d, a) {
      var n, s, f, o, p, v, M, y, U = i.indexOf("."), I = m, A = w;
      for (U >= 0 && (o = C, C = 0, i = i.replace(".", ""), y = new O(c), v = y.pow(i.length - U), C = o, y.c = r(
        ue(te(v.c), v.e, "0"),
        10,
        l,
        e
      ), y.e = y.c.length), M = r(i, c, l, a ? (n = b, e) : (n = e, b)), f = o = M.length; M[--o] == 0; M.pop()) ;
      if (!M[0]) return n.charAt(0);
      if (U < 0 ? --f : (v.c = M, v.e = f, v.s = d, v = h(v, y, I, A, l), M = v.c, p = v.r, f = v.e), s = f + I + 1, U = M[s], o = l / 2, p = p || s < 0 || M[s + 1] != null, p = A < 4 ? (U != null || p) && (A == 0 || A == (v.s < 0 ? 3 : 2)) : U > o || U == o && (A == 4 || p || A == 6 && M[s - 1] & 1 || A == (v.s < 0 ? 8 : 7)), s < 1 || !M[0])
        i = p ? ue(n.charAt(1), -I, n.charAt(0)) : n.charAt(0);
      else {
        if (M.length = s, p)
          for (--l; ++M[--s] > l; )
            M[s] = 0, s || (++f, M = [1].concat(M));
        for (o = M.length; !M[--o]; ) ;
        for (U = 0, i = ""; U <= o; i += n.charAt(M[U++])) ;
        i = ue(i, f, n.charAt(0));
      }
      return i;
    };
  }(), h = /* @__PURE__ */ function() {
    function e(c, l, d) {
      var a, n, s, f, o = 0, p = c.length, v = l % ce, M = l / ce | 0;
      for (c = c.slice(); p--; )
        s = c[p] % ce, f = c[p] / ce | 0, a = M * s + f * v, n = v * s + a % ce * ce + o, o = (n / d | 0) + (a / ce | 0) + M * f, c[p] = n % d;
      return o && (c = [o].concat(c)), c;
    }
    function r(c, l, d, a) {
      var n, s;
      if (d != a)
        s = d > a ? 1 : -1;
      else
        for (n = s = 0; n < d; n++)
          if (c[n] != l[n]) {
            s = c[n] > l[n] ? 1 : -1;
            break;
          }
      return s;
    }
    function i(c, l, d, a) {
      for (var n = 0; d--; )
        c[d] -= n, n = c[d] < l[d] ? 1 : 0, c[d] = n * a + c[d] - l[d];
      for (; !c[0] && c.length > 1; c.splice(0, 1)) ;
    }
    return function(c, l, d, a, n) {
      var s, f, o, p, v, M, y, U, I, A, H, G, fe, ie, Z, q, se, X = c.s == l.s ? 1 : -1, J = c.c, k = l.c;
      if (!J || !J[0] || !k || !k[0])
        return new O(
          // Return NaN if either NaN, or both Infinity or 0.
          !c.s || !l.s || (J ? k && J[0] == k[0] : !k) ? NaN : (
            // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            J && J[0] == 0 || !k ? X * 0 : X / 0
          )
        );
      for (U = new O(X), I = U.c = [], f = c.e - l.e, X = d + f + 1, n || (n = oe, f = ne(c.e / L) - ne(l.e / L), X = X / L | 0), o = 0; k[o] == (J[o] || 0); o++) ;
      if (k[o] > (J[o] || 0) && f--, X < 0)
        I.push(1), p = !0;
      else {
        for (ie = J.length, q = k.length, o = 0, X += 2, v = re(n / (k[0] + 1)), v > 1 && (k = e(k, v, n), J = e(J, v, n), q = k.length, ie = J.length), fe = q, A = J.slice(0, q), H = A.length; H < q; A[H++] = 0) ;
        se = k.slice(), se = [0].concat(se), Z = k[0], k[1] >= n / 2 && Z++;
        do {
          if (v = 0, s = r(k, A, q, H), s < 0) {
            if (G = A[0], q != H && (G = G * n + (A[1] || 0)), v = re(G / Z), v > 1)
              for (v >= n && (v = n - 1), M = e(k, v, n), y = M.length, H = A.length; r(M, A, y, H) == 1; )
                v--, i(M, q < y ? se : k, y, n), y = M.length, s = 1;
            else
              v == 0 && (s = v = 1), M = k.slice(), y = M.length;
            if (y < H && (M = [0].concat(M)), i(A, M, H, n), H = A.length, s == -1)
              for (; r(k, A, q, H) < 1; )
                v++, i(A, q < H ? se : k, H, n), H = A.length;
          } else s === 0 && (v++, A = [0]);
          I[o++] = v, A[0] ? A[H++] = J[fe] || 0 : (A = [J[fe]], H = 1);
        } while ((fe++ < ie || A[0] != null) && X--);
        p = A[0] != null, I[0] || I.splice(0, 1);
      }
      if (n == oe) {
        for (o = 1, X = I[0]; X >= 10; X /= 10, o++) ;
        B(U, d + (U.e = o + f * L - 1) + 1, a, p);
      } else
        U.e = f, U.r = +p;
      return U;
    };
  }();
  function Y(e, r, i, c) {
    var l, d, a, n, s;
    if (i == null ? i = w : j(i, 0, 8), !e.c) return e.toString();
    if (l = e.c[0], a = e.e, r == null)
      s = te(e.c), s = c == 1 || c == 2 && (a <= D || a >= E) ? Oe(s, a) : ue(s, a, "0");
    else if (e = B(new O(e), r, i), d = e.e, s = te(e.c), n = s.length, c == 1 || c == 2 && (r <= d || d <= D)) {
      for (; n < r; s += "0", n++) ;
      s = Oe(s, d);
    } else if (r -= a, s = ue(s, d, "0"), d + 1 > n) {
      if (--r > 0) for (s += "."; r--; s += "0") ;
    } else if (r += d - n, r > 0)
      for (d + 1 == n && (s += "."); r--; s += "0") ;
    return e.s < 0 && l ? "-" + s : s;
  }
  function K(e, r) {
    for (var i, c, l = 1, d = new O(e[0]); l < e.length; l++)
      c = new O(e[l]), (!c.s || (i = ae(d, c)) === r || i === 0 && d.s === r) && (d = c);
    return d;
  }
  function W(e, r, i) {
    for (var c = 1, l = r.length; !r[--l]; r.pop()) ;
    for (l = r[0]; l >= 10; l /= 10, c++) ;
    return (i = c + i * L - 1) > T ? e.c = e.e = null : i < R ? e.c = [e.e = 0] : (e.e = i, e.c = r), e;
  }
  $ = /* @__PURE__ */ function() {
    var e = /^(-?)0([xbo])(?=\w[\w.]*$)/i, r = /^([^.]+)\.$/, i = /^\.([^.]+)$/, c = /^-?(Infinity|NaN)$/, l = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
    return function(d, a, n, s) {
      var f, o = n ? a : a.replace(l, "");
      if (c.test(o))
        d.s = isNaN(o) ? null : o < 0 ? -1 : 1;
      else {
        if (!n && (o = o.replace(e, function(p, v, M) {
          return f = (M = M.toLowerCase()) == "x" ? 16 : M == "b" ? 2 : 8, !s || s == f ? v : p;
        }), s && (f = s, o = o.replace(r, "$1").replace(i, "0.$1")), a != o))
          return new O(o, f);
        if (O.DEBUG)
          throw Error(Q + "Not a" + (s ? " base " + s : "") + " number: " + a);
        d.s = null;
      }
      d.c = d.e = null;
    };
  }();
  function B(e, r, i, c) {
    var l, d, a, n, s, f, o, p = e.c, v = ve;
    if (p) {
      e: {
        for (l = 1, n = p[0]; n >= 10; n /= 10, l++) ;
        if (d = r - l, d < 0)
          d += L, a = r, s = p[f = 0], o = re(s / v[l - a - 1] % 10);
        else if (f = Ne((d + 1) / L), f >= p.length)
          if (c) {
            for (; p.length <= f; p.push(0)) ;
            s = o = 0, l = 1, d %= L, a = d - L + 1;
          } else
            break e;
        else {
          for (s = n = p[f], l = 1; n >= 10; n /= 10, l++) ;
          d %= L, a = d - L + l, o = a < 0 ? 0 : re(s / v[l - a - 1] % 10);
        }
        if (c = c || r < 0 || // Are there any non-zero digits after the rounding digit?
        // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
        // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
        p[f + 1] != null || (a < 0 ? s : s % v[l - a - 1]), c = i < 4 ? (o || c) && (i == 0 || i == (e.s < 0 ? 3 : 2)) : o > 5 || o == 5 && (i == 4 || c || i == 6 && // Check whether the digit to the left of the rounding digit is odd.
        (d > 0 ? a > 0 ? s / v[l - a] : 0 : p[f - 1]) % 10 & 1 || i == (e.s < 0 ? 8 : 7)), r < 1 || !p[0])
          return p.length = 0, c ? (r -= e.e + 1, p[0] = v[(L - r % L) % L], e.e = -r || 0) : p[0] = e.e = 0, e;
        if (d == 0 ? (p.length = f, n = 1, f--) : (p.length = f + 1, n = v[L - d], p[f] = a > 0 ? re(s / v[l - a] % v[a]) * n : 0), c)
          for (; ; )
            if (f == 0) {
              for (d = 1, a = p[0]; a >= 10; a /= 10, d++) ;
              for (a = p[0] += n, n = 1; a >= 10; a /= 10, n++) ;
              d != n && (e.e++, p[0] == oe && (p[0] = 1));
              break;
            } else {
              if (p[f] += n, p[f] != oe) break;
              p[f--] = 0, n = 1;
            }
        for (d = p.length; p[--d] === 0; p.pop()) ;
      }
      e.e > T ? e.c = e.e = null : e.e < R && (e.c = [e.e = 0]);
    }
    return e;
  }
  function P(e) {
    var r, i = e.e;
    return i === null ? e.toString() : (r = te(e.c), r = i <= D || i >= E ? Oe(r, i) : ue(r, i, "0"), e.s < 0 ? "-" + r : r);
  }
  return u.absoluteValue = u.abs = function() {
    var e = new O(this);
    return e.s < 0 && (e.s = 1), e;
  }, u.comparedTo = function(e, r) {
    return ae(this, new O(e, r));
  }, u.decimalPlaces = u.dp = function(e, r) {
    var i, c, l, d = this;
    if (e != null)
      return j(e, 0, V), r == null ? r = w : j(r, 0, 8), B(new O(d), e + d.e + 1, r);
    if (!(i = d.c)) return null;
    if (c = ((l = i.length - 1) - ne(this.e / L)) * L, l = i[l]) for (; l % 10 == 0; l /= 10, c--) ;
    return c < 0 && (c = 0), c;
  }, u.dividedBy = u.div = function(e, r) {
    return h(this, new O(e, r), m, w);
  }, u.dividedToIntegerBy = u.idiv = function(e, r) {
    return h(this, new O(e, r), 0, 1);
  }, u.exponentiatedBy = u.pow = function(e, r) {
    var i, c, l, d, a, n, s, f, o, p = this;
    if (e = new O(e), e.c && !e.isInteger())
      throw Error(Q + "Exponent not an integer: " + P(e));
    if (r != null && (r = new O(r)), n = e.e > 14, !p.c || !p.c[0] || p.c[0] == 1 && !p.e && p.c.length == 1 || !e.c || !e.c[0])
      return o = new O(Math.pow(+P(p), n ? e.s * (2 - me(e)) : +P(e))), r ? o.mod(r) : o;
    if (s = e.s < 0, r) {
      if (r.c ? !r.c[0] : !r.s) return new O(NaN);
      c = !s && p.isInteger() && r.isInteger(), c && (p = p.mod(r));
    } else {
      if (e.e > 9 && (p.e > 0 || p.e < -1 || (p.e == 0 ? p.c[0] > 1 || n && p.c[1] >= 24e7 : p.c[0] < 8e13 || n && p.c[0] <= 9999975e7)))
        return d = p.s < 0 && me(e) ? -0 : 0, p.e > -1 && (d = 1 / d), new O(s ? 1 / d : d);
      C && (d = Ne(C / L + 2));
    }
    for (n ? (i = new O(0.5), s && (e.s = 1), f = me(e)) : (l = Math.abs(+P(e)), f = l % 2), o = new O(N); ; ) {
      if (f) {
        if (o = o.times(p), !o.c) break;
        d ? o.c.length > d && (o.c.length = d) : c && (o = o.mod(r));
      }
      if (l) {
        if (l = re(l / 2), l === 0) break;
        f = l % 2;
      } else if (e = e.times(i), B(e, e.e + 1, 1), e.e > 14)
        f = me(e);
      else {
        if (l = +P(e), l === 0) break;
        f = l % 2;
      }
      p = p.times(p), d ? p.c && p.c.length > d && (p.c.length = d) : c && (p = p.mod(r));
    }
    return c ? o : (s && (o = N.div(o)), r ? o.mod(r) : d ? B(o, C, w, a) : o);
  }, u.integerValue = function(e) {
    var r = new O(this);
    return e == null ? e = w : j(e, 0, 8), B(r, r.e + 1, e);
  }, u.isEqualTo = u.eq = function(e, r) {
    return ae(this, new O(e, r)) === 0;
  }, u.isFinite = function() {
    return !!this.c;
  }, u.isGreaterThan = u.gt = function(e, r) {
    return ae(this, new O(e, r)) > 0;
  }, u.isGreaterThanOrEqualTo = u.gte = function(e, r) {
    return (r = ae(this, new O(e, r))) === 1 || r === 0;
  }, u.isInteger = function() {
    return !!this.c && ne(this.e / L) > this.c.length - 2;
  }, u.isLessThan = u.lt = function(e, r) {
    return ae(this, new O(e, r)) < 0;
  }, u.isLessThanOrEqualTo = u.lte = function(e, r) {
    return (r = ae(this, new O(e, r))) === -1 || r === 0;
  }, u.isNaN = function() {
    return !this.s;
  }, u.isNegative = function() {
    return this.s < 0;
  }, u.isPositive = function() {
    return this.s > 0;
  }, u.isZero = function() {
    return !!this.c && this.c[0] == 0;
  }, u.minus = function(e, r) {
    var i, c, l, d, a = this, n = a.s;
    if (e = new O(e, r), r = e.s, !n || !r) return new O(NaN);
    if (n != r)
      return e.s = -r, a.plus(e);
    var s = a.e / L, f = e.e / L, o = a.c, p = e.c;
    if (!s || !f) {
      if (!o || !p) return o ? (e.s = -r, e) : new O(p ? a : NaN);
      if (!o[0] || !p[0])
        return p[0] ? (e.s = -r, e) : new O(o[0] ? a : (
          // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
          w == 3 ? -0 : 0
        ));
    }
    if (s = ne(s), f = ne(f), o = o.slice(), n = s - f) {
      for ((d = n < 0) ? (n = -n, l = o) : (f = s, l = p), l.reverse(), r = n; r--; l.push(0)) ;
      l.reverse();
    } else
      for (c = (d = (n = o.length) < (r = p.length)) ? n : r, n = r = 0; r < c; r++)
        if (o[r] != p[r]) {
          d = o[r] < p[r];
          break;
        }
    if (d && (l = o, o = p, p = l, e.s = -e.s), r = (c = p.length) - (i = o.length), r > 0) for (; r--; o[i++] = 0) ;
    for (r = oe - 1; c > n; ) {
      if (o[--c] < p[c]) {
        for (i = c; i && !o[--i]; o[i] = r) ;
        --o[i], o[c] += oe;
      }
      o[c] -= p[c];
    }
    for (; o[0] == 0; o.splice(0, 1), --f) ;
    return o[0] ? W(e, o, f) : (e.s = w == 3 ? -1 : 1, e.c = [e.e = 0], e);
  }, u.modulo = u.mod = function(e, r) {
    var i, c, l = this;
    return e = new O(e, r), !l.c || !e.s || e.c && !e.c[0] ? new O(NaN) : !e.c || l.c && !l.c[0] ? new O(l) : (x == 9 ? (c = e.s, e.s = 1, i = h(l, e, 0, 3), e.s = c, i.s *= c) : i = h(l, e, 0, x), e = l.minus(i.times(e)), !e.c[0] && x == 1 && (e.s = l.s), e);
  }, u.multipliedBy = u.times = function(e, r) {
    var i, c, l, d, a, n, s, f, o, p, v, M, y, U, I, A = this, H = A.c, G = (e = new O(e, r)).c;
    if (!H || !G || !H[0] || !G[0])
      return !A.s || !e.s || H && !H[0] && !G || G && !G[0] && !H ? e.c = e.e = e.s = null : (e.s *= A.s, !H || !G ? e.c = e.e = null : (e.c = [0], e.e = 0)), e;
    for (c = ne(A.e / L) + ne(e.e / L), e.s *= A.s, s = H.length, p = G.length, s < p && (y = H, H = G, G = y, l = s, s = p, p = l), l = s + p, y = []; l--; y.push(0)) ;
    for (U = oe, I = ce, l = p; --l >= 0; ) {
      for (i = 0, v = G[l] % I, M = G[l] / I | 0, a = s, d = l + a; d > l; )
        f = H[--a] % I, o = H[a] / I | 0, n = M * f + o * v, f = v * f + n % I * I + y[d] + i, i = (f / U | 0) + (n / I | 0) + M * o, y[d--] = f % U;
      y[d] = i;
    }
    return i ? ++c : y.splice(0, 1), W(e, y, c);
  }, u.negated = function() {
    var e = new O(this);
    return e.s = -e.s || null, e;
  }, u.plus = function(e, r) {
    var i, c = this, l = c.s;
    if (e = new O(e, r), r = e.s, !l || !r) return new O(NaN);
    if (l != r)
      return e.s = -r, c.minus(e);
    var d = c.e / L, a = e.e / L, n = c.c, s = e.c;
    if (!d || !a) {
      if (!n || !s) return new O(l / 0);
      if (!n[0] || !s[0]) return s[0] ? e : new O(n[0] ? c : l * 0);
    }
    if (d = ne(d), a = ne(a), n = n.slice(), l = d - a) {
      for (l > 0 ? (a = d, i = s) : (l = -l, i = n), i.reverse(); l--; i.push(0)) ;
      i.reverse();
    }
    for (l = n.length, r = s.length, l - r < 0 && (i = s, s = n, n = i, r = l), l = 0; r; )
      l = (n[--r] = n[r] + s[r] + l) / oe | 0, n[r] = oe === n[r] ? 0 : n[r] % oe;
    return l && (n = [l].concat(n), ++a), W(e, n, a);
  }, u.precision = u.sd = function(e, r) {
    var i, c, l, d = this;
    if (e != null && e !== !!e)
      return j(e, 1, V), r == null ? r = w : j(r, 0, 8), B(new O(d), e, r);
    if (!(i = d.c)) return null;
    if (l = i.length - 1, c = l * L + 1, l = i[l]) {
      for (; l % 10 == 0; l /= 10, c--) ;
      for (l = i[0]; l >= 10; l /= 10, c++) ;
    }
    return e && d.e + 1 > c && (c = d.e + 1), c;
  }, u.shiftedBy = function(e) {
    return j(e, -we, we), this.times("1e" + e);
  }, u.squareRoot = u.sqrt = function() {
    var e, r, i, c, l, d = this, a = d.c, n = d.s, s = d.e, f = m + 4, o = new O("0.5");
    if (n !== 1 || !a || !a[0])
      return new O(!n || n < 0 && (!a || a[0]) ? NaN : a ? d : 1 / 0);
    if (n = Math.sqrt(+P(d)), n == 0 || n == 1 / 0 ? (r = te(a), (r.length + s) % 2 == 0 && (r += "0"), n = Math.sqrt(+r), s = ne((s + 1) / 2) - (s < 0 || s % 2), n == 1 / 0 ? r = "5e" + s : (r = n.toExponential(), r = r.slice(0, r.indexOf("e") + 1) + s), i = new O(r)) : i = new O(n + ""), i.c[0]) {
      for (s = i.e, n = s + f, n < 3 && (n = 0); ; )
        if (l = i, i = o.times(l.plus(h(d, l, f, 1))), te(l.c).slice(0, n) === (r = te(i.c)).slice(0, n))
          if (i.e < s && --n, r = r.slice(n - 3, n + 1), r == "9999" || !c && r == "4999") {
            if (!c && (B(l, l.e + m + 2, 0), l.times(l).eq(d))) {
              i = l;
              break;
            }
            f += 4, n += 4, c = 1;
          } else {
            (!+r || !+r.slice(1) && r.charAt(0) == "5") && (B(i, i.e + m + 2, 1), e = !i.times(i).eq(d));
            break;
          }
    }
    return B(i, i.e + m + 1, w, e);
  }, u.toExponential = function(e, r) {
    return e != null && (j(e, 0, V), e++), Y(this, e, r, 1);
  }, u.toFixed = function(e, r) {
    return e != null && (j(e, 0, V), e = e + this.e + 1), Y(this, e, r);
  }, u.toFormat = function(e, r, i) {
    var c, l = this;
    if (i == null)
      e != null && r && typeof r == "object" ? (i = r, r = null) : e && typeof e == "object" ? (i = e, e = r = null) : i = S;
    else if (typeof i != "object")
      throw Error(Q + "Argument not an object: " + i);
    if (c = l.toFixed(e, r), l.c) {
      var d, a = c.split("."), n = +i.groupSize, s = +i.secondaryGroupSize, f = i.groupSeparator || "", o = a[0], p = a[1], v = l.s < 0, M = v ? o.slice(1) : o, y = M.length;
      if (s && (d = n, n = s, s = d, y -= d), n > 0 && y > 0) {
        for (d = y % n || n, o = M.substr(0, d); d < y; d += n) o += f + M.substr(d, n);
        s > 0 && (o += f + M.slice(d)), v && (o = "-" + o);
      }
      c = p ? o + (i.decimalSeparator || "") + ((s = +i.fractionGroupSize) ? p.replace(
        new RegExp("\\d{" + s + "}\\B", "g"),
        "$&" + (i.fractionGroupSeparator || "")
      ) : p) : o;
    }
    return (i.prefix || "") + c + (i.suffix || "");
  }, u.toFraction = function(e) {
    var r, i, c, l, d, a, n, s, f, o, p, v, M = this, y = M.c;
    if (e != null && (n = new O(e), !n.isInteger() && (n.c || n.s !== 1) || n.lt(N)))
      throw Error(Q + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + P(n));
    if (!y) return new O(M);
    for (r = new O(N), f = i = new O(N), c = s = new O(N), v = te(y), d = r.e = v.length - M.e - 1, r.c[0] = ve[(a = d % L) < 0 ? L + a : a], e = !e || n.comparedTo(r) > 0 ? d > 0 ? r : f : n, a = T, T = 1 / 0, n = new O(v), s.c[0] = 0; o = h(n, r, 0, 1), l = i.plus(o.times(c)), l.comparedTo(e) != 1; )
      i = c, c = l, f = s.plus(o.times(l = f)), s = l, r = n.minus(o.times(l = r)), n = l;
    return l = h(e.minus(i), c, 0, 1), s = s.plus(l.times(f)), i = i.plus(l.times(c)), s.s = f.s = M.s, d = d * 2, p = h(f, c, d, w).minus(M).abs().comparedTo(
      h(s, i, d, w).minus(M).abs()
    ) < 1 ? [f, c] : [s, i], T = a, p;
  }, u.toNumber = function() {
    return +P(this);
  }, u.toPrecision = function(e, r) {
    return e != null && j(e, 1, V), Y(this, e, r, 2);
  }, u.toString = function(e) {
    var r, i = this, c = i.s, l = i.e;
    return l === null ? c ? (r = "Infinity", c < 0 && (r = "-" + r)) : r = "NaN" : (e == null ? r = l <= D || l >= E ? Oe(te(i.c), l) : ue(te(i.c), l, "0") : e === 10 && z ? (i = B(new O(i), m + l + 1, w), r = ue(te(i.c), i.e, "0")) : (j(e, 2, b.length, "Base"), r = g(ue(te(i.c), l, "0"), 10, e, c, !0)), c < 0 && i.c[0] && (r = "-" + r)), r;
  }, u.valueOf = u.toJSON = function() {
    return P(this);
  }, u._isBigNumber = !0, u[Symbol.toStringTag] = "BigNumber", u[Symbol.for("nodejs.util.inspect.custom")] = u.valueOf, t != null && O.set(t), O;
}
function ne(t) {
  var h = t | 0;
  return t > 0 || t === h ? h : h - 1;
}
function te(t) {
  for (var h, g, $ = 1, u = t.length, N = t[0] + ""; $ < u; ) {
    for (h = t[$++] + "", g = L - h.length; g--; h = "0" + h) ;
    N += h;
  }
  for (u = N.length; N.charCodeAt(--u) === 48; ) ;
  return N.slice(0, u + 1 || 1);
}
function ae(t, h) {
  var g, $, u = t.c, N = h.c, m = t.s, w = h.s, D = t.e, E = h.e;
  if (!m || !w) return null;
  if (g = u && !u[0], $ = N && !N[0], g || $) return g ? $ ? 0 : -w : m;
  if (m != w) return m;
  if (g = m < 0, $ = D == E, !u || !N) return $ ? 0 : !u ^ g ? 1 : -1;
  if (!$) return D > E ^ g ? 1 : -1;
  for (w = (D = u.length) < (E = N.length) ? D : E, m = 0; m < w; m++) if (u[m] != N[m]) return u[m] > N[m] ^ g ? 1 : -1;
  return D == E ? 0 : D > E ^ g ? 1 : -1;
}
function j(t, h, g, $) {
  if (t < h || t > g || t !== re(t))
    throw Error(Q + ($ || "Argument") + (typeof t == "number" ? t < h || t > g ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(t));
}
function me(t) {
  var h = t.c.length - 1;
  return ne(t.e / L) == h && t.c[h] % 2 != 0;
}
function Oe(t, h) {
  return (t.length > 1 ? t.charAt(0) + "." + t.slice(1) : t) + (h < 0 ? "e" : "e+") + h;
}
function ue(t, h, g) {
  var $, u;
  if (h < 0) {
    for (u = g + "."; ++h; u += g) ;
    t = u + t;
  } else if ($ = t.length, ++h > $) {
    for (u = g, h -= $; --h; u += g) ;
    t += u;
  } else h < $ && (t = t.slice(0, h) + "." + t.slice(h));
  return t;
}
var Me = Ce(), Ee = /* @__PURE__ */ ((t) => (t[t.RED_UP_GREEN_DOWN = 0] = "RED_UP_GREEN_DOWN", t[t.GREEN_UP_RED_DOWN = 1] = "GREEN_UP_RED_DOWN", t))(Ee || {}), de = /* @__PURE__ */ ((t) => (t[t.CLASS = 1] = "CLASS", t[t.COLOR = 2] = "COLOR", t))(de || {}), ge = /* @__PURE__ */ ((t) => (t[t.HK = 0] = "HK", t[t.US = 1] = "US", t))(ge || {}), F = /* @__PURE__ */ ((t) => (t[t.ZERO = 0] = "ZERO", t[t.ONE = 1] = "ONE", t[t.TWO = 2] = "TWO", t[t.FOUR = 4] = "FOUR", t[t.EIGHT = 8] = "EIGHT", t[t.TEN = 10] = "TEN", t))(F || {}), pe = /* @__PURE__ */ ((t) => (t[t.STOCK = 1] = "STOCK", t[t.ETF = 2] = "ETF", t[t.WARRANT = 3] = "WARRANT", t[t.INDEX = 4] = "INDEX", t[t.PLATE = 5] = "PLATE", t[t.OTHER = 6] = "OTHER", t[t.FUND = 7] = "FUND", t[t.BOND = 8] = "BOND", t[t.ETN = 9] = "ETN", t[t.OTC = 10] = "OTC", t[t.GN = 11] = "GN", t[t.HY = 12] = "HY", t))(pe || {});
const Ye = {
  1: 3,
  // 股票
  4: 2,
  // 指数
  12: 3
  // 行业
}, We = {
  1: 4,
  // 股票
  11: 4,
  // 概念
  12: 4,
  // 行业
  4: 2,
  // 指数
  10: 6
  // OTC
};
var Ie = /* @__PURE__ */ ((t) => (t[t.VIEW_ONLY = 1] = "VIEW_ONLY", t[t.OPERATIONAL = 2] = "OPERATIONAL", t))(Ie || {}), Se = /* @__PURE__ */ ((t) => (t.SUB = "SUB", t.CANCEL_SUB = "CANCEL_SUB", t))(Se || {});
const ze = {
  "0000100": "HSI",
  "0001400": "HSCEI",
  // 指数
  "0001500": "HSCCI"
  /* RED_CHIP */
  // 行业
};
var _e = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ye(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var He = { exports: {} };
(function(t, h) {
  (function(g, $) {
    t.exports = $();
  })(_e, function() {
    var g = 1e3, $ = 6e4, u = 36e5, N = "millisecond", m = "second", w = "minute", D = "hour", E = "day", R = "week", T = "month", _ = "quarter", x = "year", C = "date", S = "Invalid Date", b = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, z = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, O = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(a) {
      var n = ["th", "st", "nd", "rd"], s = a % 100;
      return "[" + a + (n[(s - 20) % 10] || n[s] || n[0]) + "]";
    } }, Y = function(a, n, s) {
      var f = String(a);
      return !f || f.length >= n ? a : "" + Array(n + 1 - f.length).join(s) + a;
    }, K = { s: Y, z: function(a) {
      var n = -a.utcOffset(), s = Math.abs(n), f = Math.floor(s / 60), o = s % 60;
      return (n <= 0 ? "+" : "-") + Y(f, 2, "0") + ":" + Y(o, 2, "0");
    }, m: function a(n, s) {
      if (n.date() < s.date()) return -a(s, n);
      var f = 12 * (s.year() - n.year()) + (s.month() - n.month()), o = n.clone().add(f, T), p = s - o < 0, v = n.clone().add(f + (p ? -1 : 1), T);
      return +(-(f + (s - o) / (p ? o - v : v - o)) || 0);
    }, a: function(a) {
      return a < 0 ? Math.ceil(a) || 0 : Math.floor(a);
    }, p: function(a) {
      return { M: T, y: x, w: R, d: E, D: C, h: D, m: w, s: m, ms: N, Q: _ }[a] || String(a || "").toLowerCase().replace(/s$/, "");
    }, u: function(a) {
      return a === void 0;
    } }, W = "en", B = {};
    B[W] = O;
    var P = "$isDayjsObject", e = function(a) {
      return a instanceof l || !(!a || !a[P]);
    }, r = function a(n, s, f) {
      var o;
      if (!n) return W;
      if (typeof n == "string") {
        var p = n.toLowerCase();
        B[p] && (o = p), s && (B[p] = s, o = p);
        var v = n.split("-");
        if (!o && v.length > 1) return a(v[0]);
      } else {
        var M = n.name;
        B[M] = n, o = M;
      }
      return !f && o && (W = o), o || !f && W;
    }, i = function(a, n) {
      if (e(a)) return a.clone();
      var s = typeof n == "object" ? n : {};
      return s.date = a, s.args = arguments, new l(s);
    }, c = K;
    c.l = r, c.i = e, c.w = function(a, n) {
      return i(a, { locale: n.$L, utc: n.$u, x: n.$x, $offset: n.$offset });
    };
    var l = function() {
      function a(s) {
        this.$L = r(s.locale, null, !0), this.parse(s), this.$x = this.$x || s.x || {}, this[P] = !0;
      }
      var n = a.prototype;
      return n.parse = function(s) {
        this.$d = function(f) {
          var o = f.date, p = f.utc;
          if (o === null) return /* @__PURE__ */ new Date(NaN);
          if (c.u(o)) return /* @__PURE__ */ new Date();
          if (o instanceof Date) return new Date(o);
          if (typeof o == "string" && !/Z$/i.test(o)) {
            var v = o.match(b);
            if (v) {
              var M = v[2] - 1 || 0, y = (v[7] || "0").substring(0, 3);
              return p ? new Date(Date.UTC(v[1], M, v[3] || 1, v[4] || 0, v[5] || 0, v[6] || 0, y)) : new Date(v[1], M, v[3] || 1, v[4] || 0, v[5] || 0, v[6] || 0, y);
            }
          }
          return new Date(o);
        }(s), this.init();
      }, n.init = function() {
        var s = this.$d;
        this.$y = s.getFullYear(), this.$M = s.getMonth(), this.$D = s.getDate(), this.$W = s.getDay(), this.$H = s.getHours(), this.$m = s.getMinutes(), this.$s = s.getSeconds(), this.$ms = s.getMilliseconds();
      }, n.$utils = function() {
        return c;
      }, n.isValid = function() {
        return this.$d.toString() !== S;
      }, n.isSame = function(s, f) {
        var o = i(s);
        return this.startOf(f) <= o && o <= this.endOf(f);
      }, n.isAfter = function(s, f) {
        return i(s) < this.startOf(f);
      }, n.isBefore = function(s, f) {
        return this.endOf(f) < i(s);
      }, n.$g = function(s, f, o) {
        return c.u(s) ? this[f] : this.set(o, s);
      }, n.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, n.valueOf = function() {
        return this.$d.getTime();
      }, n.startOf = function(s, f) {
        var o = this, p = !!c.u(f) || f, v = c.p(s), M = function(ie, Z) {
          var q = c.w(o.$u ? Date.UTC(o.$y, Z, ie) : new Date(o.$y, Z, ie), o);
          return p ? q : q.endOf(E);
        }, y = function(ie, Z) {
          return c.w(o.toDate()[ie].apply(o.toDate("s"), (p ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Z)), o);
        }, U = this.$W, I = this.$M, A = this.$D, H = "set" + (this.$u ? "UTC" : "");
        switch (v) {
          case x:
            return p ? M(1, 0) : M(31, 11);
          case T:
            return p ? M(1, I) : M(0, I + 1);
          case R:
            var G = this.$locale().weekStart || 0, fe = (U < G ? U + 7 : U) - G;
            return M(p ? A - fe : A + (6 - fe), I);
          case E:
          case C:
            return y(H + "Hours", 0);
          case D:
            return y(H + "Minutes", 1);
          case w:
            return y(H + "Seconds", 2);
          case m:
            return y(H + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, n.endOf = function(s) {
        return this.startOf(s, !1);
      }, n.$set = function(s, f) {
        var o, p = c.p(s), v = "set" + (this.$u ? "UTC" : ""), M = (o = {}, o[E] = v + "Date", o[C] = v + "Date", o[T] = v + "Month", o[x] = v + "FullYear", o[D] = v + "Hours", o[w] = v + "Minutes", o[m] = v + "Seconds", o[N] = v + "Milliseconds", o)[p], y = p === E ? this.$D + (f - this.$W) : f;
        if (p === T || p === x) {
          var U = this.clone().set(C, 1);
          U.$d[M](y), U.init(), this.$d = U.set(C, Math.min(this.$D, U.daysInMonth())).$d;
        } else M && this.$d[M](y);
        return this.init(), this;
      }, n.set = function(s, f) {
        return this.clone().$set(s, f);
      }, n.get = function(s) {
        return this[c.p(s)]();
      }, n.add = function(s, f) {
        var o, p = this;
        s = Number(s);
        var v = c.p(f), M = function(I) {
          var A = i(p);
          return c.w(A.date(A.date() + Math.round(I * s)), p);
        };
        if (v === T) return this.set(T, this.$M + s);
        if (v === x) return this.set(x, this.$y + s);
        if (v === E) return M(1);
        if (v === R) return M(7);
        var y = (o = {}, o[w] = $, o[D] = u, o[m] = g, o)[v] || 1, U = this.$d.getTime() + s * y;
        return c.w(U, this);
      }, n.subtract = function(s, f) {
        return this.add(-1 * s, f);
      }, n.format = function(s) {
        var f = this, o = this.$locale();
        if (!this.isValid()) return o.invalidDate || S;
        var p = s || "YYYY-MM-DDTHH:mm:ssZ", v = c.z(this), M = this.$H, y = this.$m, U = this.$M, I = o.weekdays, A = o.months, H = o.meridiem, G = function(Z, q, se, X) {
          return Z && (Z[q] || Z(f, p)) || se[q].slice(0, X);
        }, fe = function(Z) {
          return c.s(M % 12 || 12, Z, "0");
        }, ie = H || function(Z, q, se) {
          var X = Z < 12 ? "AM" : "PM";
          return se ? X.toLowerCase() : X;
        };
        return p.replace(z, function(Z, q) {
          return q || function(se) {
            switch (se) {
              case "YY":
                return String(f.$y).slice(-2);
              case "YYYY":
                return c.s(f.$y, 4, "0");
              case "M":
                return U + 1;
              case "MM":
                return c.s(U + 1, 2, "0");
              case "MMM":
                return G(o.monthsShort, U, A, 3);
              case "MMMM":
                return G(A, U);
              case "D":
                return f.$D;
              case "DD":
                return c.s(f.$D, 2, "0");
              case "d":
                return String(f.$W);
              case "dd":
                return G(o.weekdaysMin, f.$W, I, 2);
              case "ddd":
                return G(o.weekdaysShort, f.$W, I, 3);
              case "dddd":
                return I[f.$W];
              case "H":
                return String(M);
              case "HH":
                return c.s(M, 2, "0");
              case "h":
                return fe(1);
              case "hh":
                return fe(2);
              case "a":
                return ie(M, y, !0);
              case "A":
                return ie(M, y, !1);
              case "m":
                return String(y);
              case "mm":
                return c.s(y, 2, "0");
              case "s":
                return String(f.$s);
              case "ss":
                return c.s(f.$s, 2, "0");
              case "SSS":
                return c.s(f.$ms, 3, "0");
              case "Z":
                return v;
            }
            return null;
          }(Z) || v.replace(":", "");
        });
      }, n.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, n.diff = function(s, f, o) {
        var p, v = this, M = c.p(f), y = i(s), U = (y.utcOffset() - this.utcOffset()) * $, I = this - y, A = function() {
          return c.m(v, y);
        };
        switch (M) {
          case x:
            p = A() / 12;
            break;
          case T:
            p = A();
            break;
          case _:
            p = A() / 3;
            break;
          case R:
            p = (I - U) / 6048e5;
            break;
          case E:
            p = (I - U) / 864e5;
            break;
          case D:
            p = I / u;
            break;
          case w:
            p = I / $;
            break;
          case m:
            p = I / g;
            break;
          default:
            p = I;
        }
        return o ? p : c.a(p);
      }, n.daysInMonth = function() {
        return this.endOf(T).$D;
      }, n.$locale = function() {
        return B[this.$L];
      }, n.locale = function(s, f) {
        if (!s) return this.$L;
        var o = this.clone(), p = r(s, f, !0);
        return p && (o.$L = p), o;
      }, n.clone = function() {
        return c.w(this.$d, this);
      }, n.toDate = function() {
        return new Date(this.valueOf());
      }, n.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, n.toISOString = function() {
        return this.$d.toISOString();
      }, n.toString = function() {
        return this.$d.toUTCString();
      }, a;
    }(), d = l.prototype;
    return i.prototype = d, [["$ms", N], ["$s", m], ["$m", w], ["$H", D], ["$W", E], ["$M", T], ["$y", x], ["$D", C]].forEach(function(a) {
      d[a[1]] = function(n) {
        return this.$g(n, a[0], a[1]);
      };
    }), i.extend = function(a, n) {
      return a.$i || (a(n, l, i), a.$i = !0), i;
    }, i.locale = r, i.isDayjs = e, i.unix = function(a) {
      return i(1e3 * a);
    }, i.en = B[W], i.Ls = B, i.p = {}, i;
  });
})(He);
var Ge = He.exports;
const Te = /* @__PURE__ */ ye(Ge);
var Pe = { exports: {} };
(function(t, h) {
  (function(g, $) {
    t.exports = $();
  })(_e, function() {
    var g = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, $ = {};
    return function(u, N, m) {
      var w, D = function(_, x, C) {
        C === void 0 && (C = {});
        var S = new Date(_), b = function(z, O) {
          O === void 0 && (O = {});
          var Y = O.timeZoneName || "short", K = z + "|" + Y, W = $[K];
          return W || (W = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: z, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: Y }), $[K] = W), W;
        }(x, C);
        return b.formatToParts(S);
      }, E = function(_, x) {
        for (var C = D(_, x), S = [], b = 0; b < C.length; b += 1) {
          var z = C[b], O = z.type, Y = z.value, K = g[O];
          K >= 0 && (S[K] = parseInt(Y, 10));
        }
        var W = S[3], B = W === 24 ? 0 : W, P = S[0] + "-" + S[1] + "-" + S[2] + " " + B + ":" + S[4] + ":" + S[5] + ":000", e = +_;
        return (m.utc(P).valueOf() - (e -= e % 1e3)) / 6e4;
      }, R = N.prototype;
      R.tz = function(_, x) {
        _ === void 0 && (_ = w);
        var C = this.utcOffset(), S = this.toDate(), b = S.toLocaleString("en-US", { timeZone: _ }), z = Math.round((S - new Date(b)) / 1e3 / 60), O = m(b, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(S.getTimezoneOffset() / 15) - z, !0);
        if (x) {
          var Y = O.utcOffset();
          O = O.add(C - Y, "minute");
        }
        return O.$x.$timezone = _, O;
      }, R.offsetName = function(_) {
        var x = this.$x.$timezone || m.tz.guess(), C = D(this.valueOf(), x, { timeZoneName: _ }).find(function(S) {
          return S.type.toLowerCase() === "timezonename";
        });
        return C && C.value;
      };
      var T = R.startOf;
      R.startOf = function(_, x) {
        if (!this.$x || !this.$x.$timezone) return T.call(this, _, x);
        var C = m(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return T.call(C, _, x).tz(this.$x.$timezone, !0);
      }, m.tz = function(_, x, C) {
        var S = C && x, b = C || x || w, z = E(+m(), b);
        if (typeof _ != "string") return m(_).tz(b);
        var O = function(B, P, e) {
          var r = B - 60 * P * 1e3, i = E(r, e);
          if (P === i) return [r, P];
          var c = E(r -= 60 * (i - P) * 1e3, e);
          return i === c ? [r, i] : [B - 60 * Math.min(i, c) * 1e3, Math.max(i, c)];
        }(m.utc(_, S).valueOf(), z, b), Y = O[0], K = O[1], W = m(Y).utcOffset(K);
        return W.$x.$timezone = b, W;
      }, m.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, m.tz.setDefault = function(_) {
        w = _;
      };
    };
  });
})(Pe);
var je = Pe.exports;
const ke = /* @__PURE__ */ ye(je);
var Fe = { exports: {} };
(function(t, h) {
  (function(g, $) {
    t.exports = $();
  })(_e, function() {
    var g = "minute", $ = /[+-]\d\d(?::?\d\d)?/g, u = /([+-]|\d\d)/g;
    return function(N, m, w) {
      var D = m.prototype;
      w.utc = function(S) {
        var b = { date: S, utc: !0, args: arguments };
        return new m(b);
      }, D.utc = function(S) {
        var b = w(this.toDate(), { locale: this.$L, utc: !0 });
        return S ? b.add(this.utcOffset(), g) : b;
      }, D.local = function() {
        return w(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var E = D.parse;
      D.parse = function(S) {
        S.utc && (this.$u = !0), this.$utils().u(S.$offset) || (this.$offset = S.$offset), E.call(this, S);
      };
      var R = D.init;
      D.init = function() {
        if (this.$u) {
          var S = this.$d;
          this.$y = S.getUTCFullYear(), this.$M = S.getUTCMonth(), this.$D = S.getUTCDate(), this.$W = S.getUTCDay(), this.$H = S.getUTCHours(), this.$m = S.getUTCMinutes(), this.$s = S.getUTCSeconds(), this.$ms = S.getUTCMilliseconds();
        } else R.call(this);
      };
      var T = D.utcOffset;
      D.utcOffset = function(S, b) {
        var z = this.$utils().u;
        if (z(S)) return this.$u ? 0 : z(this.$offset) ? T.call(this) : this.$offset;
        if (typeof S == "string" && (S = function(W) {
          W === void 0 && (W = "");
          var B = W.match($);
          if (!B) return null;
          var P = ("" + B[0]).match(u) || ["-", 0, 0], e = P[0], r = 60 * +P[1] + +P[2];
          return r === 0 ? 0 : e === "+" ? r : -r;
        }(S), S === null)) return this;
        var O = Math.abs(S) <= 16 ? 60 * S : S, Y = this;
        if (b) return Y.$offset = O, Y.$u = S === 0, Y;
        if (S !== 0) {
          var K = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (Y = this.local().add(O + K, g)).$offset = O, Y.$x.$localOffset = K;
        } else Y = this.utc();
        return Y;
      };
      var _ = D.format;
      D.format = function(S) {
        var b = S || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return _.call(this, b);
      }, D.valueOf = function() {
        var S = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * S;
      }, D.isUTC = function() {
        return !!this.$u;
      }, D.toISOString = function() {
        return this.toDate().toISOString();
      }, D.toString = function() {
        return this.toDate().toUTCString();
      };
      var x = D.toDate;
      D.toDate = function(S) {
        return S === "s" && this.$offset ? w(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : x.call(this);
      };
      var C = D.diff;
      D.diff = function(S, b, z) {
        if (S && this.$u === S.$u) return C.call(this, S, b, z);
        var O = this.local(), Y = w(S).local();
        return C.call(O, Y, b, z);
      };
    };
  });
})(Fe);
var qe = Fe.exports;
const Ze = /* @__PURE__ */ ye(qe);
Te.extend(Ze);
const ee = Me;
Te.extend(ke);
const he = 1e4, le = 1e8, $e = 1e12, xe = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"], Ve = ["0000100", "0001400", "0001500"];
function Le(t) {
  Array.isArray(t) ? t.forEach((h) => {
    window == null || window.$socket.removeAllListeners(h);
  }) : window == null || window.$socket.removeAllListeners(t);
}
function nt({ socketKey: t, params: h, cb: g }) {
  return window == null || window.$socket.emit(Se.SUB, {
    event: t,
    ...h
  }), Le(t), window == null || window.$socket.on(t, g), () => {
    window == null || window.$socket.emit(Se.CANCEL_SUB, {
      event: t,
      ...h
    }), Le(t);
  };
}
function Ke(t, h) {
  return !t || !h ? h : (Object.keys(h).forEach((g) => {
    const $ = h[g], u = Object.prototype.toString.call($);
    if (u === "[object Object]") {
      const N = t[g] || {};
      t[g] = Ke(N, $);
    } else u === "[object Array]" ? t[g] = JSON.parse(JSON.stringify($)) : t[g] = h[g];
  }), t);
}
function it({
  num: t,
  stockType: h = pe.STOCK,
  type: g = de.CLASS,
  quotationColor: $
}) {
  const u = h === pe.OTC ? 6 : 4;
  return Xe({
    num: Ae(t, { decimal: u }),
    type: g,
    quotationColor: $
  });
}
function Xe({
  num: t,
  type: h = de.CLASS,
  quotationColor: g = Ee.RED_UP_GREEN_DOWN
}) {
  if (t = +t, !t) return "";
  if (h === de.CLASS)
    return (g ? "gu" : "ru") + (t > 0 ? "-up" : "-down");
  const $ = ["var(--wd-fluctuation-rise-text)", "var(--wd-fluctuation-fall-text)"];
  return t > 0 ? g ? $[1] : $[0] : g ? $[0] : $[1];
}
function Je({
  num: t,
  type: h = de.CLASS,
  quotationColor: g = Ee.RED_UP_GREEN_DOWN
}) {
  if (t = +t, !t) return "";
  if (h === de.CLASS)
    return (g ? "tooltip-gu" : "tooltip-ru") + (t > 0 ? "-up" : "-down");
  const $ = ["var(--wd-fluctuation-rise-hover)", "var(--wd-fluctuation-fall-hover)"];
  return t > 0 ? g ? $[1] : $[0] : g ? $[0] : $[1];
}
function st({
  num: t,
  type: h = de.CLASS,
  stockType: g = pe.STOCK,
  quotationColor: $
}) {
  const u = g === pe.OTC ? 6 : 4;
  return Je({ num: Ae(t, { decimal: u }), type: h, quotationColor: $ });
}
function ot(t) {
  return typeof t == "string" || Number.isInteger(t) ? 0 : 4;
}
const Ue = {
  [ge.HK]: "Asia/Shanghai",
  [ge.US]: "America/New_York"
};
function ft({ date: t, format: h = "/", regionType: g = ge.HK }) {
  if (t === 0 || t === void 0 || t === null)
    return {
      mainDate: "--",
      allDate: "--",
      monDay: "--",
      mon: "--",
      yearMon: "--",
      noSsDate: "--",
      noYearDate: "--",
      noYearTime: "--",
      miniDate: "--",
      mdDate: "--",
      kData: "--",
      yymmdd: "--",
      yymmddN: "--",
      yymm: "--",
      mmdd: "--",
      hms: "--",
      hm: "--",
      year: "--",
      dd: "--",
      mm: "--",
      hh: "--",
      hmss: "--"
    };
  const $ = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"], u = Te.tz(t, Ue[g] ?? Ue[ge.HK]), N = u.format("YYYY"), m = u.format("MM"), w = u.format("DD"), D = u.format("HH"), E = u.format("mm"), R = u.format("ss"), T = u.format("d"), _ = N + h + m + h + w, x = u.millisecond();
  return {
    mainDate: _,
    allDate: `${_} ${D}:${E}:${R}`,
    monDay: `${m}/${w}`,
    mon: m,
    yearMon: `${N}/${m}`,
    noSsDate: `${_} ${D}:${E}`,
    noYearDate: `${m}${h}${w} ${D}:${E}`,
    noYearTime: `${m}${h}${w} ${D}:${E}:${R}`,
    miniDate: `${D}:${E}`,
    mdDate: `${m}${h}${w}`,
    kData: `${_} ${$[Number(T)]}`,
    yymmdd: `${N}${h}${m}${h}${w}`,
    yymmddN: `${N}年${m}$月${w}日`,
    yymm: `${N}${h}${m}`,
    mmdd: `${m}${h}${w}`,
    hms: `${D}:${E}:${R}`,
    hm: `${D}:${E} `,
    year: N,
    dd: w,
    mm: E,
    hh: D,
    hmss: `${D}:${E}:${R}:${x}`
  };
}
function ut({ max: t, min: h, includeZeroAxis: g, defaultMax: $ = 400 }) {
  g && (t >= 0 && h >= 0 ? h = 0 : t <= 0 && h <= 0 ? t = 0 : Math.abs(t) >= Math.abs(h) ? h = -1 * t : t = -1 * h);
  const u = F.TEN ** (parseInt(t.toString()).toString().length - F.TWO), N = F.TEN ** (parseInt(h.toString()).toString().length - F.TWO), m = Math.abs(t) >= F.TEN ? Math.ceil(t / u) * u : t, w = Math.abs(h) >= F.TEN ? Math.floor(h / N) * N : h;
  let D, E = m - w;
  if (E >= F.TEN) {
    D = F.TEN ** (parseInt(E.toString()).toString().length - F.TWO);
    let _ = E / D;
    _ / F.TEN >= F.EIGHT && (_ = _ / F.TEN, D *= F.TEN), _ += E % D ? F.ONE : F.ZERO;
    const x = _ % F.FOUR;
    _ += x > F.ZERO ? F.FOUR - x : F.ZERO, E = _ * D;
  } else
    E = E + (E % F.FOUR ? F.FOUR - E % F.FOUR : F.ZERO), D = E / F.FOUR;
  let R, T;
  return t * h < F.ZERO && g ? (R = E / F.TWO, T = -F.ONE * E / F.TWO) : g && m === F.ZERO ? (R = F.ZERO, T = R - E) : (T = Math.abs(w) / D, T = (h < 0 ? -F.ONE * Math.ceil(T) : F.ONE * Math.floor(T)) * D, R = E + T), [
    {
      max: !t && !h ? $ : R,
      min: !t && !h ? 0 : T,
      interval: new ee(!t && !h ? $ : E).div(4).toNumber()
    }
  ];
}
function ct({
  min: t,
  interval: h,
  maxGap: g = 4,
  isConversion: $ = !0,
  decimal: u
}) {
  let N = 0;
  for (let m = 0; m <= g; m++) {
    const w = new ee(h).times(m).plus(t).toNumber();
    N = Qe({
      value: w,
      isConversion: $,
      maxYAxisWidth: N,
      decimal: u
    }).maxYAxisWidth;
  }
  return N;
}
function Qe({
  value: t,
  isConversion: h = !0,
  maxYAxisWidth: g = 0,
  size: $ = 12,
  decimal: u
}) {
  let N = "", m = t, w = 0;
  const D = Math.abs(t);
  if (h && D >= he) {
    const E = et({
      value: t,
      decimal: u
    });
    m = E.value, N = E.unit, w = be({ text: `${m}${N}`, size: $ }) + 12;
  } else
    u !== void 0 && (m = new ee(m).toFixed(u)), w = be({ text: `${m.toString()}`, size: $ }) + 10;
  return g = Math.max(w, g), {
    value: m,
    unit: N,
    maxYAxisWidth: g
  };
}
function et({ value: t, decimal: h }) {
  const g = Math.abs(t);
  let $ = "", u = t;
  return g >= he && (g >= he && g < le ? (u = new ee(t).div(he).toNumber(), $ = "万") : g >= le && g < $e ? (u = new ee(t).div(le).toNumber(), $ = "亿") : (u = new ee(t).div($e).toNumber(), $ = "万亿")), h !== void 0 && (u = new ee(u).toFixed(h)), {
    value: u,
    unit: $
  };
}
function be({ text: t, size: h = 12, pdNum: g = 0 }) {
  var N;
  let $ = 0;
  const u = document.createElement("span");
  return u.innerText = t, u.className = "_column_fit_class", document.querySelector("body").appendChild(u), document.querySelector("._column_fit_class").style.fontSize = h + "px", $ = document.querySelector("._column_fit_class").offsetWidth, (N = document.querySelector("._column_fit_class")) == null || N.remove(), $ + g;
}
function Ae(t, h = {}) {
  const {
    decimal: g,
    n: $,
    z: u,
    t: N,
    pn: m,
    r: w,
    suffix: D,
    times: E,
    div: R,
    os: T,
    osDecimal: _
  } = Object.assign(
    {
      decimal: 0,
      z: null,
      n: "--",
      t: !1,
      pn: !1,
      r: 4,
      suffix: "",
      times: 1,
      div: 1,
      os: !1,
      osDecimal: 2
    },
    h
  );
  let x = new ee(t);
  if (x.isNaN() || !x.isFinite() || R === 0)
    return $;
  if (x.eq(0))
    return u !== null ? u : `${x.toFormat(g)}${D}`;
  const C = {
    groupSeparator: N ? "," : "",
    decimalSeparator: ".",
    groupSize: 3
  };
  x = x.times(E).div(R);
  let S = "", b = "", z = 1, O = g;
  if (T) {
    const K = ee(t).abs().toNumber(), B = [
      {
        rule: (P) => P >= he && P < le,
        div: he,
        suffix: De(he)
      },
      {
        rule: (P) => P >= le && P < $e,
        div: le,
        suffix: De(le)
      },
      {
        rule: (P) => P >= $e,
        div: $e,
        suffix: De($e)
      }
    ].find((P) => P.rule(K));
    B && (b = B.suffix, z = B.div, O = _ === null ? g : _);
  }
  return S = x.div(z).toFormat(O, w, C), (m && x.gt(0) ? "+" : "") + S + b + D;
}
function at(t, h) {
  let g = "";
  return t === void 0 || t === "" || t === null ? g = "" : g = t.toString().slice(h), g;
}
function lt({
  date: t,
  format: h
  //locale = 'zh-CN',
}) {
  if (t === 0 || t === void 0 || t === null)
    return {
      mainDate: "--",
      allDate: "--",
      monDay: "--",
      mon: "--",
      yearMon: "--",
      noSsDate: "--",
      noYearDate: "--",
      noYearTime: "--",
      miniDate: "--",
      mdDate: "--",
      kData: "--",
      yymmdd: "--",
      yymmddN: "--",
      yymm: "--",
      mmdd: "--",
      hms: "--",
      hm: "--",
      year: "--",
      dd: "--",
      mm: "--",
      hmss: "--",
      weekDay: "--"
    };
  h = h || "/";
  const g = new Date(t), $ = g.getFullYear(), u = g.getMonth() + 1 < 10 ? "0" + (g.getMonth() + 1) : g.getMonth() + 1, N = g.getDate() < 10 ? "0" + g.getDate() : g.getDate(), m = (g.getHours() < 10 ? "0" + g.getHours() : g.getHours()) + ":", w = g.getMinutes() < 10 ? "0" + g.getMinutes() : g.getMinutes(), D = ":" + (g.getSeconds() < 10 ? "0" + g.getSeconds() : g.getSeconds()), E = g.getDay(), R = g.getMilliseconds(), T = R < 10 ? ":00" + R : R < 100 ? ":0" + R : ":" + R;
  let _ = "";
  return _ = $ + h + u + h + N, {
    mainDate: _,
    allDate: _ + " " + m + w + D,
    monDay: u + "/" + N,
    mon: u,
    yearMon: $ + "/" + u,
    noSsDate: _ + " " + m + w,
    noYearDate: u + h + N + " " + m + w,
    noYearTime: u + h + N + " " + m + w + D,
    miniDate: m + w,
    mdDate: u + h + N,
    kData: _ + " " + xe[E],
    yymmdd: $ + h + u + h + N,
    yymmddN: $ + "年" + u + "月" + N + "日",
    yymm: $ + h + u,
    mmdd: u + h + N,
    hms: m + w + D,
    hm: m + w,
    year: $,
    dd: N,
    mm: w,
    hmss: m + w + D + T,
    weekDay: xe[E]
  };
}
function ht(t) {
  if (typeof t != "number" && typeof t != "string")
    return "—";
  {
    const h = [
      [
        (u) => Math.abs(u) >= 1e9,
        () => new ee(t / 1e9).toFixed(1) + "B"
      ],
      [
        (u) => Math.abs(u) >= 1e6 && Math.abs(u) < 1e9,
        () => new ee(t / 1e9).toFixed(1) + "B"
      ],
      [
        (u) => Math.abs(u) >= 1e3 && Math.abs(u) < 1e6,
        () => new ee(t / 1e3).toFixed(1) + "K"
      ]
    ];
    t = Number(t);
    let g;
    const $ = h.find((u) => u[0](t));
    return $ ? g = $[1]() : g = t + "", g;
  }
}
function dt(t, h) {
  const g = [];
  return t.forEach(($) => {
    const u = {};
    $.forEach((N, m) => {
      u[h[m]] = N;
    }), g.push(u);
  }), g;
}
function gt(t, h) {
  const g = {};
  return t.forEach(($, u) => {
    !$ && typeof $ == "object" ? g[h[u]] = null : !isNaN(Number($)) && h[u] !== "code" ? g[h[u]] = Number($) : g[h[u]] = $;
  }), g;
}
function $t(t) {
  if (!t) return;
  const h = {
    RMB: "人民币",
    HKD: "港元",
    JPY: "日元",
    USD: "美元",
    EUR: "欧元",
    SGD: "新币",
    MOP: "澳门元",
    MYR: "马来西亚林吉特",
    CAD: "加拿大元",
    TWD: "新台币",
    AUD: "澳元",
    THB: "泰铢"
  };
  return h[t] || h.RMB;
}
function pt({
  source: t,
  path: h,
  defaultVal: g
}) {
  if (Object.prototype.toString.call(t) !== "[object Object]" || Object.keys(t).length === 0 || typeof h != "string")
    return g;
  const $ = h.split(".");
  let u = JSON.parse(JSON.stringify(t)), N = $[0] || "";
  for (let m = 1; m < $.length; m++) {
    if (N = $[m], u[N] === null || u[N] === void 0)
      return g;
    u = u[N];
  }
  return u;
}
function De(t) {
  if (typeof t != "number" && !t) return "";
  t < 0 && (t *= -1);
  const h = [
    "个",
    "十",
    "百",
    "千",
    "万",
    "十万",
    "百万",
    "千万",
    "亿",
    "十亿",
    "百亿",
    "千亿",
    "万亿"
  ], g = Math.floor(Math.log10(t));
  return g < h.length ? h[g] : "";
}
function mt(t) {
  const h = [
    {
      code: "$",
      encode: "%24"
    },
    {
      code: "?",
      encode: "%3F"
    },
    {
      code: "#",
      encode: "%23"
    },
    {
      code: "&",
      encode: "%26"
    },
    {
      code: "=",
      encode: "%3D"
    },
    {
      code: "[",
      encode: "%5B"
    },
    {
      code: "]",
      encode: "%5D"
    },
    {
      code: "%",
      encode: "%25"
    },
    {
      code: "^",
      encode: "%5E"
    }
  ];
  function g($) {
    for (const u of h)
      if (u.code === $)
        return u.encode;
  }
  return t.replace(/[#$?&=[\]%^]/g, g);
}
function Ot({
  value: t,
  decimal: h = 2,
  isOriginal: g = !1,
  sign: $ = !1,
  isPercent: u = !1,
  pn: N = !1
}) {
  if (new ee(t).isNaN() || t === void 0) return "--";
  switch (t = g ? Me(t).times(100).toNumber() : t, N = N ?? !1, !0) {
    case (t < 0.01 && t > 0):
      return "<0.01" + (u ? "%" : "");
    case (t < 100 && t > 99.99):
      return ">99.99" + (u ? "%" : "");
    default:
      return Ae(t, { decimal: h, t: $, r: Me.ROUND_HALF_UP, pn: N }) + (u ? "%" : "");
  }
}
function Nt(t) {
  if (!t) return "--";
  if (Ve.includes(t)) return ze[t];
  const h = t.lastIndexOf(".");
  return h === -1 ? t : t.slice(0, h);
}
function wt(t, h = pe.STOCK) {
  const g = t === ge.HK ? Ye[h] : We[h], $ = t === ge.HK ? 3 : 4;
  return g || $;
}
function vt({ codes: t, ids: h, btnCodes: g, userInfo: $ }) {
  var w, D, E;
  const u = "*:*:*";
  let N = !1, m = !0;
  if (g && g.length > 0 && (N = g.includes(u) || g.some((R) => t.includes(R))), h) {
    const R = h.constructor === Array ? h : h.constructor === Number ? [h] : [];
    R.length && (m = ((w = $ == null ? void 0 : $.userTeamInfo) == null ? void 0 : w.operationType) === Ie.OPERATIONAL && ((D = $ == null ? void 0 : $.userTeamInfo) == null ? void 0 : D.permissionUserIds.some((T) => R.includes(T))) || ((E = $ == null ? void 0 : $.replaceUserIds) == null ? void 0 : E.some((T) => R.includes(T))));
  }
  return N && m;
}
function Dt({
  max: t,
  min: h,
  interval: g = 4,
  scale: $ = 0.2,
  isHaveBar: u = !1,
  maxVal: N = 100
}) {
  if (!t && !h)
    return [
      {
        max: N,
        min: h,
        interval: (N - h) / g
      }
    ];
  let m = t, w = h;
  if (u && h < 0 && t !== 0) {
    const D = m / Math.abs(w);
    switch (!0) {
      case D >= 3:
        w = -(m / 3);
        break;
      case (D < 3 && D >= 2):
        m = Math.abs(h) * 3;
        break;
      case (D < 2 && D >= 1):
        w = -m;
        break;
      case (D < 1 && D >= 1 / 3):
        m = Math.abs(w);
        break;
      case D < 1 / 3:
        (w % 3 === 1 || w % 3 === -2) && (w += 2), (w % 3 === 2 || w % 3 === -1) && (w += 1), m = Math.abs(w) / 3;
        break;
    }
  }
  if (u)
    m = m + Math.abs(m) * $, w = w - Math.abs(w) * $;
  else {
    const D = Math.abs(m === w ? m : m - w) / 4 * $;
    m += D, w = w >= 0 && w - D < 0 ? h : w - D;
  }
  return [
    {
      max: m,
      min: w,
      interval: (m - w) / g
    }
  ];
}
function Mt(t, h) {
  const g = {};
  t.forEach(function(u) {
    const N = u[h] + "";
    g[N] = g[N] || [], g[N].push(u);
  });
  const $ = [];
  return t.length > 0 && Reflect.ownKeys(g).forEach((u) => {
    let N = { keys: "", content: [] };
    u && (N = {
      keys: u,
      content: g[u].map((m) => ({
        label: m.name,
        value: m.code
      }))
    }, $.push(N));
  }), $;
}
function tt(t, h = {}) {
  const { isAllowNegative: g } = Object.assign(
    {
      isAllowNegative: !1
    },
    h
  );
  let $ = t + "";
  if ($ = $.replace(/^[^-\d]/g, ""), $ = g ? $.replace(/[^\d.-]/g, "") : $.replace(/[^\d.]/g, ""), $ = $.replace(/(?!^)-/g, ""), $ = $.replace(/([^\d])\./g, "$1"), $ = $.replace(/^\./g, ""), $ = $.replace(".", "$#$").replace(/\./g, "").replace("$#$", "."), $ !== "" && !$.includes(".") && $ !== "-") {
    const u = parseFloat($);
    u === 0 ? $ = `${$.includes("-") ? "-" : ""}${u}` : $ = `${u}`;
  }
  return $;
}
function St(t, h = {}) {
  const { digit: g, integer: $, isAllowNegative: u } = Object.assign(
    {
      digit: -1,
      integer: 30,
      isAllowNegative: !1
    },
    h
  );
  let N = tt(t, { isAllowNegative: u });
  if (N === null || N === "")
    return "";
  if (N === "-" || N === "-0")
    return N;
  const m = new RegExp(`^(\\-)?(\\d{${$}})\\d+(\\.\\d*)?$`);
  if (N = N.replace(m, "$1$2$3"), g !== -1) {
    const w = new Array(g).fill("\\d").join(""), D = g ? new RegExp(`^(\\-)?(\\d+)(\\.${w}).*$`) : new RegExp("^(\\-)?(\\d+).*$");
    N = g ? N.replace(D, "$1$2$3") : N.replace(D, "$1$2");
  }
  return /\.$/.test(N) || /\.\d*0$/.test(N), N;
}
function rt(t) {
  return Function('"use strict";return (' + t + ")")();
}
function Et(t, h) {
  let { b: g } = h;
  const { n: $ } = h;
  g = g || 0, t += "";
  let u = "";
  if ($ && t.charAt(0) === "-" && (u = "-"), t === "" || t === "0") return t;
  if (g === 0)
    return t = t.replace(/[^\d0]/g, ""), t = t === "" ? "" : parseInt(t), t;
  t = t.replace(/[^\d.]/g, ""), t = t.replace(/^\./g, ""), t = t.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
  const N = new Array(g).fill("\\d").join(""), m = g ? "/^(\\-)*(\\d+)\\.(" + N + ").*$/" : "/^(\\-)*(\\d+)\\.(\\d+).*$/";
  return t = t.replace(rt(m), "$1$2.$3"), t.indexOf(".") < 0 && t !== "" && (t = parseFloat(t)), u === "-" && (t = `-${t}`), t;
}
export {
  Ue as ZONE_ENUM_MAP,
  dt as arrToJson,
  gt as arrToObj,
  Qe as bigNumberUnit,
  it as chgColorTo,
  st as chgTooltipColorTo,
  Xe as colorTo,
  ct as computedLeftWidth,
  mt as encodeSearchKey,
  ft as getDay,
  wt as getStockPointNum,
  ot as getStockQualityDecimal,
  be as getTextWidth,
  lt as getTime,
  Mt as groupBy,
  ht as handleNum,
  Ot as inThanMinOrMax,
  St as inputLimit,
  Ke as mergeCoverObject,
  Et as numRemTail,
  et as numberConvert,
  Ae as numberFormat,
  tt as numberLimit,
  De as numerals,
  nt as openSocketCurry,
  vt as permissions,
  pt as queryValueByKey,
  Le as removeAllSocketListeners,
  ut as setYAxis,
  Dt as setYaxisScale,
  at as spliceLen,
  Nt as stockCodeSub,
  $t as switchCurrency,
  Je as tooltipColorTo
};
